import { api } from '@/lib/api'
import type { AvailabilityStatus, AvailabilityView } from './types'

export async function getMyAvailability(): Promise<AvailabilityView[]> {
  const r = await api.get<AvailabilityView[]>('/api/me/availability')
  return r.data
}

export async function setMyAvailability(
  teamId: number,
  status: AvailabilityStatus,
): Promise<AvailabilityView> {
  const r = await api.put<AvailabilityView>(`/api/me/availability/${teamId}`, { status })
  return r.data
}
